module.exports = __webpack_public_path__ + "img/cta_gradientwave.ed1db711.png";